import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, TextField } from "@mui/material";
import { WalmartSettings } from "../../api";

export interface WalmartSettingsControlProps {
  settings?: WalmartSettings;
  onChange: (settings: Partial<WalmartSettings>) => void;
}

export const WalmartSettingsControl = (props: WalmartSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">Walmart settings</FormLabel>
      <FormGroup>
        <TextField label="Client ID" required variant="standard" value={settings?.clientId ?? ""} onChange={(e) => onChange({ clientId: e.target.value })} />
        <TextField label="Client Secret" variant="standard" value={settings?.clientSecret ?? ""} onChange={(e) => onChange({ clientSecret: e.target.value })} />
        <FormControlLabel label="Sandbox" control={<Checkbox checked={settings?.sandbox ?? false} onChange={(e, c) => onChange({ sandbox: c })} />} />
      </FormGroup>
    </FormControl>
  );
};
